export default __webpack_public_path__ + "static/media/Group 42615.b555891d.png";